import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAppleNewton: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAppleNewton"><Path d="M6.22102 2.5C5.55366 4.61159 5.97527 6.32097 7.37317 8.06893M7.37317 8.06893C-5.40358 13.2119 13.4775 28.1256 17.5772 18.1255C21.3216 16.6348 21.6223 13.1591 20.249 10M7.37317 8.06893C8.21142 6.04565 9.30574 4.82806 10.5101 4.22621" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 3.5V11" stroke="currentColor" strokeLinecap="square"/><Path d="M12 9L14.5 11.5L17 9" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconAppleNewton;
